import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "main" }

import store from "@/store";
import { baseHeader, sideMenu, fullLoading } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'default',
  props: {
    menuList: {},
    menuActive: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(sideMenu), {
      menus: __props.menuList,
      "menu-active": __props.menuActive
    }, null, 8, ["menus", "menu-active"]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(baseHeader)),
      _createElementVNode("main", _hoisted_3, [
        _renderSlot(_ctx.$slots, "main")
      ])
    ]),
    (_unref(store).getters.loading)
      ? (_openBlock(), _createBlock(_unref(fullLoading), { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})